import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zm3.008-92.992a416 416 0 1 0 0-832 416 416 0 0 0 0 832zM320 320h384v384H320V320z" /></svg>

const StopCircle = React.forwardRef((props, ref) => {
  return (
    <IconBase name="stop-circle" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

StopCircle.displayName = 'IconStopCircle'

export default StopCircle
